import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import { useForm, SubmitHandler } from "react-hook-form"
import MpgInput from '../../../CommonFormComp/MpgInput';
import MpgSelect from '../../../CommonFormComp/MpgSelect';
import MenuItem from "@mui/material/MenuItem";
import Grid from '@mui/material/Grid';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import CloseIcon from '@mui/icons-material/Close';
import { useGetLanguageListQuery } from '../../../reactQueries/commonRQHooks';
import { v4 as uuidv4 } from 'uuid';
import { useGetSignedInUserDetails } from "../../../hooksAndFunctions/customHooks/useGetSignedInUserDetails";
import { useState } from "react";
import { useEffect } from "react";


const AddBioDialog = ({ open, setOpen, bioDetailTableData, setBioDetailTableData,cmsData }) => {
    const { userName } = useGetSignedInUserDetails()

    // console.log("gl-data", bioDetailTableData)

    /**get languagelist */
    const { isSuccess, isFetching, error, data: masterLangList, isError } = useGetLanguageListQuery();

    // #region Cms content handling
    const fetchBioDetailsComponentLabel = (key) => {
        if (cmsData?.pageContent && cmsData?.pageContent["BioDetailsComponent"]) {
            const adminBioDetailsLabel = cmsData.pageContent["BioDetailsComponent"];
            return returnLabel(adminBioDetailsLabel?.Labels, key)
        }
        return '';
    }

    const fetchCommonCMSLabel = (key) => {
        if (cmsData?.pageContent && cmsData?.pageContent["CommonComponent"]) {
            const commonLabels = cmsData.pageContent["CommonComponent"];
            return returnLabel(commonLabels?.Labels, key)
        }
        return '';
    }

    const returnLabel = (labelArray=[], key) => {
            return labelArray.find((x) => x.Key === key)?.Phrase || '';
    }
    // #endregion

    /**modified Bio Array to get unique titlenames for dropdown */
    const [uniqueTemplateTitleList, setUniqueTemplateTitleList] = useState([])
    useEffect(() => {

        if (!!bioDetailTableData && !!bioDetailTableData.length) {
            let list = []
            bioDetailTableData.forEach((eachBioTableData) => {
                list.push(eachBioTableData.TemplateTitle)
            })

            const set = new Set(list)
            const array = Array.from(set)
            setUniqueTemplateTitleList(array)
        }
    }, [bioDetailTableData])

    /** state to provide way to enter titlename either by input or Select dropdown */
    const [showInput, setShowInput] = useState(true)

    useEffect(() => {
        if (!!bioDetailTableData && !!bioDetailTableData.length) {
            setShowInput(false)
        } else {
            setShowInput(true)
        }
    }, [bioDetailTableData])

    /** */
    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick") {
            return '';
        } else {
            setOpen(false);
        }
        reset(defaultValues)
    }

    /**form handling */
    const defaultValues = {
        bio_title: '',
        bio_lang: '',
        bio_content: ''
    }
    const bioFormSchema = yup.object().shape({
        bio_title: !!showInput ? yup.string()
            .required('This field is required').max(40)
            .test("noDuplicateEntry", "This entry exists already. Please use dropdown to select.", (input) => {
                if (uniqueTemplateTitleList.includes(input)) {
                    return false
                } else {
                    return true
                }
            })
            : yup.string().required('This field is required').max(40),
        bio_lang: yup.string().required(),
        bio_content: yup.string().max(1300),
    });

    const bioFormInstance = useForm({
        defaultValues,
        resolver: yupResolver(bioFormSchema)
    });

    const { setValue, reset, watch } = bioFormInstance

    /**getting lang Id to disable lang related to selected bio template to avoid duplicates */
    const [langIdsForSelectedTemplate, setLangIdsForSelectedTemplate] = useState([])
    const bioTitle = watch("bio_title")
    useEffect(() => {
        if (!!bioTitle) {
            const founfItems = bioDetailTableData.filter((item) => item.TemplateTitle === bioTitle)

            if (!!founfItems) {
                const langIdList = founfItems.map((item) => {
                    return item.LanguageId
                })
                setLangIdsForSelectedTemplate(langIdList)
            }
        }
    }, [bioTitle])

    const onSubmitForBioForm = (data) => {
        const selectedLangDetails = !!masterLangList && masterLangList.find((item) => item.Id === data.bio_lang)

        let selectedTemplateTitle = data.bio_title

        setBioDetailTableData([...bioDetailTableData, {
            Id: uuidv4(),/**temporaryly created to track local entry */
            flag: "notFromDB",
            TemplateTitle: selectedTemplateTitle,
            LanguageId: selectedLangDetails.Id,
            LanguageDescription: selectedLangDetails.LanguageDescription || '',
            Content: data.bio_content || '',
            IsActive: true,/**used for softdelete inDB */
            CreatedBy: userName
        }])
        // console.log("gl-sub", data)

        reset(defaultValues)
        setOpen(false);
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            disableEscapeKeyDown
        >
            <Box
                sx={{ width: { sm: '500px' } }}
                component="form"
                noValidate
                autoComplete="off"
                onSubmit={bioFormInstance.handleSubmit(onSubmitForBioForm)}
            >

                <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
                    {fetchBioDetailsComponentLabel("BioDetails.AddNewBioHeading")}
                    <IconButton
                        sx={{ ml: 'auto' }}
                        onClick={handleClose}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText></DialogContentText>
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                    >
                        {
                            !!showInput && (
                                <MpgInput
                                    rhfFormInstance={bioFormInstance}
                                    label={fetchBioDetailsComponentLabel("BioDetails.BioTemplate")}
                                    name={'bio_title'}
                                    fullWidth
                                />
                            )
                        }
                        {
                            !showInput && (
                                <MpgSelect
                                    rhfFormInstance={bioFormInstance}
                                    label={fetchBioDetailsComponentLabel("BioDetails.SelectBioTemplate")}
                                    name={'bio_title'}
                                >
                                    {
                                        !!uniqueTemplateTitleList && uniqueTemplateTitleList.map((item) => (
                                            <MenuItem
                                                key={item}
                                                value={item}
                                            >
                                                {item}
                                            </MenuItem>
                                        ))
                                    }
                                </MpgSelect>
                            )
                        }
                        <div>
                            <Button onClick={() => {
                                setValue("bio_title", "")
                                setValue("bio_lang", "")
                                setLangIdsForSelectedTemplate("")
                                setShowInput(!!showInput ? false : true)
                            }}>{!showInput ? fetchBioDetailsComponentLabel('BioDetails.AddTemplate') : fetchBioDetailsComponentLabel('BioDetails.SelectTemplate')}</Button>
                        </div>


                        <MpgSelect
                            rhfFormInstance={bioFormInstance}
                            label={fetchBioDetailsComponentLabel("BioDetails.BioLanguage")}
                            name={'bio_lang'}
                        >
                            {
                                !!masterLangList && masterLangList.map((eachLang) => (
                                    <MenuItem
                                        key={eachLang.Id}
                                        value={eachLang.Id}
                                        /**disable lang for selected template title */
                                        disabled={!!langIdsForSelectedTemplate.includes(eachLang.Id)}
                                    >
                                        {eachLang.LanguageDescription}

                                    </MenuItem>
                                ))
                            }
                        </MpgSelect>

                        <MpgInput
                            rhfFormInstance={bioFormInstance}
                            label={fetchBioDetailsComponentLabel("BioDetails.BioContent")}
                            name={'bio_content'}
                            placeholder={fetchBioDetailsComponentLabel("BioDetails.PlaceholderBioContent")}
                            multiline
                            rows={20}
                            fullWidth
                        />
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button type='submit'>{fetchCommonCMSLabel('Common.Add')}</Button>
                    <Button onClick={handleClose}>{fetchCommonCMSLabel('Common.Cancel')}</Button>
                </DialogActions>
            </Box>
        </Dialog>
    )
}
export default AddBioDialog